export default "__VITE_ASSET__D0fLc7YT__"